import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=e5f390ac&"
import script from "./policy.vue?vue&type=script&setup=true&lang=js&"
export * from "./policy.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5f390ac')) {
      api.createRecord('e5f390ac', component.options)
    } else {
      api.reload('e5f390ac', component.options)
    }
    module.hot.accept("./policy.vue?vue&type=template&id=e5f390ac&", function () {
      api.rerender('e5f390ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/policy.vue"
export default component.exports